<template>
  <div>
    <vm-table
        ref="vmTable"
        height="65vh"
        :filter.sync="filter"
        module="basic"
        url="applications/todo/all">
      <template slot="adSearch">
        <div class="vm-search">
          <vm-search label="单据类型">
            <el-input v-model.trim="filter.formText" clearable/>
          </vm-search>
          <vm-search label="单据编号">
            <el-input v-model.trim="filter.billNO" clearable/>
          </vm-search>
          <vm-search label="节点名称">
            <el-input v-model.trim="filter.descrpt" clearable/>
          </vm-search>
          <el-row>
            <vm-search label="创建时间">
              <div class="block">
                <el-date-picker
                    v-model="filter.startTime"
                    value-format="yyyy-MM-dd HH:mm:ss"
                    type="date"
                    style="width: 165px"
                    placeholder="选择开始时间"/>
              </div>
            </vm-search>
            <vm-search label="至">
              <div class="block">
                <el-date-picker
                    v-model="filter.endTime"
                    value-format="yyyy-MM-dd 23:59:59"
                    type="date"
                    style="width: 165px"
                    placeholder="选择结束时间"/>
              </div>
            </vm-search>
          </el-row>
        </div>
      </template>
      <el-table-column prop="sequID" label="主键"/>
      <el-table-column prop="formText" label="单据类型"/>
      <el-table-column prop="billNO" label="单据编号"/>
      <el-table-column prop="descrpt" label="节点名称"/>
      <el-table-column prop="createdTime" label="创建时间"/>
    </vm-table>
  </div>
</template>
<script>
  import VmTable from "@/components/VmTable.vue";
  import VmSearch from "@/components/VmSearch.vue";
  export default {
    name: "TodoList",
    components: {VmTable, VmSearch},
    data() {
      return {
        filter: {
          formText: "",
          billNO: "",
          descrpt: "",
          startTime: "",
          endTime: "",
        },
      };
    },
    mounted() {
      this.getList(1);
    },
    methods: {
      getList(pageNum) {
        this.$refs.vmTable.getList(pageNum);
      },
    },
  };
</script>
<style lang="scss" scoped>
</style>
